import { render } from "./mat-icon-button-toggle.vue?vue&type=template&id=449a5c67&scoped=true&lang=true"
import script from "./mat-icon-button-toggle.vue?vue&type=script&lang=js"
export * from "./mat-icon-button-toggle.vue?vue&type=script&lang=js"

import "./mat-icon-button-toggle.vue?vue&type=style&index=0&id=449a5c67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449a5c67"]])

export default __exports__